// utils
import { lazy, Suspense } from 'react';

// components
import { Navigate, Route, Routes } from 'react-router-dom';
import WidgetsLoader from '@components/WidgetsLoader';

// hooks
import { useRef, useEffect } from 'react';
import useAuth from '@hooks/useAuth';
import { menu, DEFAULT_HOME_ROUTE } from '@constants/menu';

// pages
const PageNotFound = lazy(() => import('@pages/PageNotFound'));
const CustomSidebar = lazy(() => import('@layout/CustomSidebar'));

const AppLayout = (props) => {
  const appRef = useRef(null);
  const { user } = useAuth();

  useEffect(() => {
    if (appRef.current) {
      appRef.current.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="app" ref={appRef}>
      <CustomSidebar open={props.open} setOpen={props.setOpen} userRole={user.role.toLowerCase()} />
      <div className="app_content">
        <Suspense fallback={<WidgetsLoader />}>
          <Routes>
            <Route
              path="/"
              element={
                <Navigate to={user.role.toLowerCase() ? DEFAULT_HOME_ROUTE : '/'} />
              }
            />
            {menu
              .filter((m) => m.role.includes(user.role.toLowerCase()))
              .map((route, index) => (
                <Route
                  path={route.link}
                  key={index}
                  element={route.component}
                />
              ))}
            <Route path="/404" element={<PageNotFound />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </div>
    </div>
  );
};

export default AppLayout;
